import React, { FunctionComponent, useCallback } from 'react';
import { ConnectedDialog } from '../ConnectedDialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { MeetingFolderForm } from '../../pages/common/forms/MeetingFolderForm';

export const MeetingFolderFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingFolderFormDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="meetingFolderFormDialog">
      <div className="popup new_trello_card_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>Add Folder</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <MeetingFolderForm />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey={'createFileFolder'} formName={'meeting-folder-form'} text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
